export function buildProductFilterKey(collectionName, docId, filterId) {
  return `${collectionName}:${docId}:${filterId}`;
}

export function parseProductFilterKey(key) {
  const parts = String(key || '').split(':');
  if (parts.length < 3) return null;
  const filterId = parts.pop();
  const docId = parts.pop();
  const collectionName = parts.join(':');
  if (!collectionName || !docId || !filterId) return null;
  return { collectionName, docId, filterId };
}

export function isCardInProductFilter(filter, categoryId, cardId) {
  return (filter.cardEntries || []).some(
    (entry) => entry.categoryId === categoryId && entry.cardId === cardId
  );
}

export function isCategoryInProductFilter(filter, categoryId) {
  return (filter.categoryIds || []).includes(categoryId);
}

/** Produtos/planos/cursos da vitrine ligados em "Acesso ao módulo". */
export function resolveCatalogSourcesFromAccess({
  selectedProducts = [],
  selectedPlans = [],
  selectedCourses = [],
}) {
  const sources = [];
  const seen = new Set();

  const add = (collectionName, docId, label) => {
    const key = `${collectionName}:${docId}`;
    if (!docId || seen.has(key)) return;
    seen.add(key);
    sources.push({
      collectionName,
      docId,
      label: label || 'Produto',
      key,
    });
  };

  for (const product of selectedProducts) {
    add('products', product.docId || product.id, product.name || product.title);
  }

  for (const plan of selectedPlans) {
    add('plans', plan.id, plan.title);
  }

  for (const course of selectedCourses) {
    add('courses', course.id, course.title);
  }

  return sources;
}
